/**
 * Ersoy Gurme — Teslimat Bölgesi seçici (Aşama 1: bölge durumu katmanı)
 *
 * SÖZLEŞME (kilitli — Aşama 2'yi yazan buna göre okur):
 *   Sepet attribute'u (insan için) : "Teslimat Bolgesi"     → "Adana / Seyhan"
 *   Sepet attribute'u (makine için): "Teslimat Bolge Kodu"  → "01-SEYHAN"
 *   Çerez / localStorage anahtarı  : "ersoy_bolge"
 *
 *   ⚠️ Anahtar adlarında Türkçe karakter YOK ve "__" öneki YOK. Sebep: "__" önekli
 *   attribute'lar Liquid'den okunamaz; Türkçe karakterler Liquid → GraphQL → Rust
 *   fonksiyon → webhook zincirinde sessiz kodlama hatası riski taşır. Kodun kendisi
 *   ASCII'ye katlanır (Ç→C, Ğ→G, İ/I→I, Ö→O, Ş→S, Ü→U), görünen ad Türkçe kalır.
 *
 *   Aşama 2 (indirim fonksiyonu) YALNIZ "Teslimat Bolge Kodu"nu okumalı — input
 *   query karmaşıklık bütçesi 28/30 ve her attribute +1 maliyetli.
 */

const COOKIE = 'ersoy_bolge';
const LS = 'ersoy_bolge';
const CEREZ_OMRU = 60 * 60 * 24 * 365; // 1 yıl

/** Türkçe adı ASCII, büyük harf, tirelenmiş koda katlar. "Yüreğir" → "YUREGIR" */
const KATLA = { Ç: 'C', Ğ: 'G', İ: 'I', I: 'I', Ö: 'O', Ş: 'S', Ü: 'U' };
function slug(ad) {
  return ad
    .toUpperCase()
    .replace(/[ÇĞİIÖŞÜ]/g, (c) => KATLA[c] || c)
    .replace(/[^A-Z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

function cerezYaz(deger) {
  const guvenli = location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${COOKIE}=${encodeURIComponent(deger)}; path=/; max-age=${CEREZ_OMRU}; SameSite=Lax${guvenli}`;
}
function cerezOku() {
  const m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
  return m ? decodeURIComponent(m[1]) : '';
}

/** /cart/update.js — attribute yazar. Boş sepette de çağrılır; hata sessizce yutulur. */
async function sepeteYaz(attrs) {
  const r = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: attrs }),
  });
  if (!r.ok) throw new Error(`cart/update.js ${r.status}`);
  return r.json();
}

class ErsoyBolgeSecici extends HTMLElement {
  connectedCallback() {
    this.adAttr = this.dataset.attrName || 'Teslimat Bolgesi';
    this.kodAttr = this.dataset.attrCode || 'Teslimat Bolge Kodu';
    this.dataUrl = this.dataset.dataUrl;
    this.hedef = (this.dataset.hedef || '').split(',').map((s) => s.trim()).filter(Boolean);
    this.prefill = this.dataset.checkoutPrefill === 'true';
    this.reloadOnChange = this.dataset.reloadOnChange === 'true';

    this.dialog = this.querySelector('[data-ebs-dialog]');
    this.form = this.querySelector('[data-ebs-form]');
    this.ilSel = this.querySelector('[data-ebs-il]');
    this.ilceSel = this.querySelector('[data-ebs-ilce]');
    this.hataEl = this.querySelector('[data-ebs-error]');
    this.kaydetBtn = this.querySelector('[data-ebs-save]');

    // Sunucudan gelen (cart.attributes) hakikat; çerez yalnız yedek.
    this.secili = {
      kod: this.dataset.selectedCode || '',
      ad: this.dataset.selectedName || '',
    };

    this.durumEl = this.querySelector('[data-ebs-status]');
    this.durumKalibi = this.dataset.statusTemplate || 'Teslimat bölgeniz {bolge} olarak kaydedildi.';

    this.querySelectorAll('[data-ebs-open]').forEach((b) =>
      b.addEventListener('click', () => this.ac(b))
    );

    // Native <dialog> odağı yalnız AÇILIŞTA odak DOM'da tetikleyicideyse geri verir.
    // Dokunmatikte buton tıklamayla odak almaz → Esc/kapat sonrası odak <body>'de kalıyordu.
    // Odağı açıkça geri veriyoruz. (Gerçek Esc testinde yakalandı.)
    this.dialog?.addEventListener('close', () => {
      if (this._tetikleyici && document.contains(this._tetikleyici)) this._tetikleyici.focus();
    });
    this.querySelectorAll('[data-ebs-cancel]').forEach((b) =>
      b.addEventListener('click', () => this.dialog?.close())
    );
    this.form?.addEventListener('submit', (e) => this.kaydet(e));
    this.ilSel?.addEventListener('change', () => this.ilceleriDoldur(this.ilSel.value));
    // Blur'da doğrula (submit'i bekleme)
    this.ilceSel?.addEventListener('blur', () => this.dogrula(false));
    // Arka plana tıklayınca kapat
    this.dialog?.addEventListener('click', (e) => {
      if (e.target === this.dialog) this.dialog.close();
    });

    this.cerezdenTazele();
    if (this.prefill) this.odemeButonlariniBagla();
  }

  /** Sepet attribute'u boş ama çerez doluysa sessizce sepete geri yaz. */
  cerezdenTazele() {
    if (this.secili.kod) {
      cerezYaz(`${this.secili.kod}|${this.secili.ad}`);
      return;
    }
    const c = cerezOku();
    if (!c || !c.includes('|')) return;
    const [kod, ad] = c.split('|');
    if (!kod || !ad) return;
    this.secili = { kod, ad };
    this.cizdir();
    sepeteYaz({ [this.adAttr]: ad, [this.kodAttr]: kod }).catch(() => {});
  }

  async veri() {
    if (this._veri) return this._veri;
    const r = await fetch(this.dataUrl, { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error(`il/ilçe verisi alınamadı (${r.status})`);
    this._veri = await r.json();
    return this._veri;
  }

  async ac(tetikleyici) {
    this._tetikleyici = tetikleyici || this.querySelector('[data-ebs-open]');
    this.hataGoster('');
    try {
      const d = await this.veri();
      // ⚠️ Liquid zaten bir placeholder <option> basıyor → `!options.length` ASLA doğru olmaz.
      // Bu yüzden eşik 1'dir, 0 değil. (Canlı testte bu hata yakalandı.)
      if (this.ilSel.options.length <= 1) {
        this.ilSel.innerHTML =
          '<option value="">İl seçin</option>' +
          d.iller.map((p) => `<option value="${p.k}">${p.a}</option>`).join('');
      }
      if (this.secili.kod) {
        const ilKod = this.secili.kod.split('-')[0];
        this.ilSel.value = ilKod;
        this.ilceleriDoldur(ilKod, this.secili.kod);
      }
    } catch (err) {
      this.hataGoster('Bölge listesi yüklenemedi. Sayfayı yenileyip tekrar deneyin.');
      console.error('[ersoy-bolge]', err);
    }
    this.dialog?.showModal();
    this.ilSel?.focus();
  }

  ilceleriDoldur(ilKod, seciliKod = '') {
    const d = this._veri;
    const il = d?.iller.find((p) => p.k === ilKod);
    if (!il) {
      this.ilceSel.innerHTML = '<option value="">Önce il seçin</option>';
      this.ilceSel.disabled = true;
      return;
    }
    this.ilceSel.disabled = false;
    this.ilceSel.innerHTML =
      '<option value="">İlçe seçin</option>' +
      il.i.map((ad) => `<option value="${slug(ad)}">${ad}</option>`).join('');
    if (seciliKod) this.ilceSel.value = seciliKod.split('-').slice(1).join('-');
    this.hataGoster('');
  }

  dogrula(sessiz = true) {
    if (!this.ilSel.value) {
      if (!sessiz) this.hataGoster('Lütfen il seçin.');
      return false;
    }
    if (!this.ilceSel.value) {
      if (!sessiz) this.hataGoster('Lütfen ilçe seçin.');
      return false;
    }
    this.hataGoster('');
    return true;
  }

  async kaydet(e) {
    e.preventDefault();
    if (!this.dogrula(false)) return;

    const il = this._veri.iller.find((p) => p.k === this.ilSel.value);
    const ilceAd = this.ilceSel.options[this.ilceSel.selectedIndex].textContent.trim();
    const kod = `${il.k}-${this.ilceSel.value}`;
    const ad = `${il.a} / ${ilceAd}`;

    this.kaydetBtn.disabled = true;
    this.kaydetBtn.dataset.yukleniyor = 'true';
    try {
      await sepeteYaz({ [this.adAttr]: ad, [this.kodAttr]: kod });
      this.secili = { kod, ad };
      cerezYaz(`${kod}|${ad}`);
      try {
        localStorage.setItem(LS, JSON.stringify({ kod, ad, il: il.a, ilce: ilceAd, ts: Date.now() }));
      } catch (_) {}
      this.cizdir();
      this.duyur(ad);
      this.dialog.close();
      this.dispatchEvent(
        new CustomEvent('ersoy:bolge-degisti', { bubbles: true, detail: { kod, ad, avantajli: this.avantajli(kod) } })
      );
      if (this.reloadOnChange) location.reload();
    } catch (err) {
      this.hataGoster('Bölge kaydedilemedi. İnternet bağlantınızı kontrol edip tekrar deneyin.');
      console.error('[ersoy-bolge]', err);
    } finally {
      this.kaydetBtn.disabled = false;
      delete this.kaydetBtn.dataset.yukleniyor;
    }
  }

  avantajli(kod = this.secili.kod) {
    return !!kod && this.hedef.includes(kod);
  }

  /** Kaydetme sonucunu ekran okuyucuya duyurur (görsel olarak gizli role="status"). */
  duyur(ad) {
    if (!this.durumEl) return;
    this.durumEl.textContent = this.durumKalibi.replace('{bolge}', ad);
  }

  hataGoster(msg) {
    if (!this.hataEl) return;
    this.hataEl.textContent = msg;
    this.hataEl.hidden = !msg;
  }

  /** Bar metnini ve avantaj rozetini yeniden çizer (sunucu render'ıyla aynı mantık). */
  cizdir() {
    const label = this.querySelector('[data-ebs-label]');
    const deger = this.querySelector('[data-ebs-value]');
    const cta = this.querySelector('[data-ebs-open]');
    const rozet = this.querySelector('[data-ebs-badge]');
    const dolu = !!this.secili.kod;
    this.dataset.state = dolu ? 'dolu' : 'bos';
    if (deger) deger.textContent = this.secili.ad;
    if (label) label.hidden = dolu;
    if (cta) cta.textContent = dolu ? cta.dataset.labelFull : cta.dataset.labelEmpty;
    if (rozet) rozet.hidden = !this.avantajli();
  }

  /**
   * Ödeme butonunu yakalar: attribute'u garanti eder, sonra checkout'a
   * il/ilçe ön-dolgusuyla gider. Sepet token'ı korunur (canlıda doğrulandı).
   * ⚠️ Shop Pay / Apple Pay gibi hızlandırılmış butonlar bu akışı ATLAR.
   */
  odemeButonlariniBagla() {
    const SEC = 'button[name="checkout"], input[name="checkout"], [data-ebs-checkout]';
    document.addEventListener(
      'click',
      async (e) => {
        const btn = e.target.closest(SEC);
        if (!btn || btn.dataset.ebsGecti === '1') return;
        if (!this.secili.kod) return; // bölge seçilmemiş → normal akış
        e.preventDefault();
        e.stopPropagation();
        const [ilKod, ...ilceParts] = this.secili.kod.split('-');
        const [ilAd, ilceAd] = this.secili.ad.split(' / ');
        try {
          await sepeteYaz({ [this.adAttr]: this.secili.ad, [this.kodAttr]: this.secili.kod });
        } catch (_) {
          /* attribute yazılamadıysa yine de checkout'a git */
        }
        const q = new URLSearchParams();
        if (ilAd) q.set('checkout[shipping_address][city]', ilAd);
        if (ilceAd) q.set('checkout[shipping_address][address2]', ilceAd);
        void ilKod; void ilceParts;
        location.href = `${window.Shopify?.routes?.root || '/'}checkout?${q.toString()}`;
      },
      true
    );
  }
}

if (!customElements.get('ersoy-bolge-secici')) {
  customElements.define('ersoy-bolge-secici', ErsoyBolgeSecici);
}
